import React from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createBarChartOption } from '../lib/chart-options';
import type { TopItemsData } from '@/entities/dashboard';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface BarChartProps {
  data?: TopItemsData;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export const BarChart: React.FC<BarChartProps> = ({
  data,
  height,
  className,
  loading,
  showExport,
  exportOptions,
  exportPosition
}) => {
  const emptyData: TopItemsData = { series: [] };
  const option = createBarChartOption(data || emptyData);

  return (
    <EChartsWrapper
      option={option}
      height={height}
      className={className}
      loading={loading}
      showExport={showExport}
      exportOptions={exportOptions}
      exportPosition={exportPosition}
    />
  );
};
